// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21P9Y","right":"styles_right__3S8uE"};